import axios, { AxiosRequestConfig, Canceler } from 'axios';

import { getConfig } from '@constants';

export class HttpTransportBrowser {

	static axios: typeof axios = axios;

	static setup() {
		const { hosts: { api } } = getConfig();

		axios.defaults.baseURL = api;
	}

	static async http(params: AxiosRequestConfig & { getAbort?(abort: Canceler): void }) {
		return axios({
			// eslint-disable-next-line import/no-named-as-default-member
			cancelToken: new axios.CancelToken((abort: Canceler) => params.getAbort && params.getAbort(abort)),
			...params,
			withCredentials: true,
		});
	}

}
